export default "__VITE_ASSET__Beosnler__"